// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const heatran: PokeData = {
  "id": 485,
  "name": "heatran",
  "height": 17,
  "weight": 4300,
  "base_experience": 270,
  "types": [
    PokeType.FIRE,
    PokeType.STEEL
  ],
  "api_moves": [
    "leer",
    "ember",
    "fire-spin",
    "scary-face",
    "metal-claw",
    "crunch",
    "ancient-power",
    "heat-wave",
    "metal-sound",
    "iron-defense",
    "earth-power",
    "fire-fang",
    "lava-plume",
    "iron-head",
    "stone-edge",
    "magma-storm"
  ],
  "moves": [
    "leer",
    "ember",
    "fire-spin",
    "scary-face",
    "metal-claw",
    "crunch",
    "ancient-power",
    "metal-sound",
    "earth-power",
    "fire-fang",
    "magma-storm",
    "sunny-day",
    "fire-punch"
  ],
  "evolution_chain": {
    "id": 246,
    "item": null,
    "species": [
      {
        "name": "heatran",
        "order": 486,
        "types": [
          PokeType.FIRE,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 101,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
